/**
 * Galeria PDP LYTI — swipe nativo + miniaturas + filtro por variante.
 */
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  class LytiPdpGallery {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('.lyti-pdp-gallery__track');
      this.thumbs = root.querySelectorAll('.lyti-pdp-gallery__thumb');
      this.currentEl = root.querySelector('[data-lyti-gallery-current]');
      this.totalEl = root.querySelector('[data-lyti-gallery-total]');
      this.section = root.closest('product-info');
      this.scrollTimer = null;
      if (!this.track) return;
      this.bind();
      this.sync();
    }

    isDesktop() {
      return DESKTOP_MQ.matches;
    }

    getSlides() {
      return Array.from(this.track.querySelectorAll('.lyti-pdp-gallery__slide')).filter(
        (slide) => !slide.classList.contains('is-filtered') && !slide.hasAttribute('hidden')
      );
    }

    getActiveIndex(slides) {
      if (!slides.length) return 0;

      if (this.isDesktop()) {
        return Math.max(
          0,
          slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
      }

      const trackRect = this.track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let activeIndex = 0;
      let minDistance = Infinity;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.left + rect.width / 2;
        const distance = Math.abs(slideCenter - center);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    sync() {
      const slides = this.getSlides();
      if (!slides.length) return;

      const activeIndex = this.getActiveIndex(slides);
      const activeSlide = slides[activeIndex];

      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === activeIndex);
      });

      this.thumbs.forEach((thumb) => {
        const isActive = thumb.dataset.target === activeSlide.dataset.mediaId;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      if (this.currentEl) this.currentEl.textContent = String(activeIndex + 1);
      if (this.totalEl) this.totalEl.textContent = String(slides.length);
    }

    goToMediaId(mediaId, smooth) {
      const slide = this.track.querySelector(`.lyti-pdp-gallery__slide[data-media-id="${mediaId}"]:not(.is-filtered):not([hidden])`);
      if (!slide) return;

      if (this.isDesktop()) {
        this.getSlides().forEach((item) => item.classList.remove('is-active'));
        slide.classList.add('is-active');
        this.sync();
        return;
      }

      this.track.scrollTo({
        left: slide.offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth',
      });
    }

    snapToNearest() {
      if (this.isDesktop()) return;
      const slides = this.getSlides();
      if (!slides.length) return;

      const activeIndex = this.getActiveIndex(slides);
      const slide = slides[activeIndex];
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      window.requestAnimationFrame(() => this.sync());
    }

    applyVariantFilters() {
      if (!this.section) return;

      const selected = [];
      this.section.querySelectorAll('variant-selects select, variant-selects input[type="radio"]:checked').forEach((el) => {
        if (el.name && el.name.startsWith('options')) {
          selected.push(normalize(el.value));
        }
      });

      this.track.querySelectorAll('.lyti-pdp-gallery__slide').forEach((slide) => {
        const groupName = normalize(slide.dataset.groupName);
        const groupValue = normalize(slide.dataset.groupValue);
        if (!groupName || !groupValue) {
          slide.classList.remove('is-filtered');
          slide.removeAttribute('hidden');
          return;
        }

        let visible = true;
        const labels = this.section.querySelectorAll('variant-selects .form__label, variant-selects legend');
        labels.forEach((label, index) => {
          const labelText = normalize(label.textContent).replace(':', '');
          if (labelText.includes(groupName) || groupName.includes(labelText)) {
            const selectedValue = selected[index];
            if (selectedValue && selectedValue !== groupValue) {
              visible = false;
            }
          }
        });

        slide.classList.toggle('is-filtered', !visible);
        slide.toggleAttribute('hidden', !visible);
      });

      const firstVisible = this.getSlides()[0];
      if (firstVisible) {
        this.goToMediaId(firstVisible.dataset.mediaId, false);
      }
      this.sync();
    }

    bind() {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.goToMediaId(thumb.dataset.target, true);
        });
      });

      this.track.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(() => this.sync());
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.snapToNearest(), 100);
        },
        { passive: true }
      );

      if (this.section) {
        this.section.addEventListener('change', () => this.applyVariantFilters());
        document.addEventListener('variant:change', (event) => {
          if (event.target && this.section.contains(event.target)) {
            this.applyVariantFilters();
          }
        });
      }

      this.track.querySelectorAll('.lyti-pdp-gallery__image').forEach((img) => {
        img.setAttribute('draggable', 'false');
      });

      if (typeof DESKTOP_MQ.addEventListener === 'function') {
        DESKTOP_MQ.addEventListener('change', () => {
          const slides = this.getSlides();
          const active = slides.find((s) => s.classList.contains('is-active')) || slides[0];
          if (active) this.goToMediaId(active.dataset.mediaId, false);
        });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.lyti-pdp-gallery').forEach((root) => {
      if (root.dataset.lytiGalleryInit) return;
      root.dataset.lytiGalleryInit = 'true';
      new LytiPdpGallery(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();